var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBookmark2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 21C5.8283 20.9995 5.65955 20.9547 5.51009 20.87C5.35563 20.7832 5.227 20.6569 5.13739 20.504C5.04778 20.3511 5.0004 20.1772 5.00009 20V5.33C4.98657 4.73032 5.20992 4.14946 5.62172 3.71332C6.03353 3.27718 6.60062 3.02089 7.20009 3H16.8001C17.3996 3.02089 17.9667 3.27718 18.3785 3.71332C18.7903 4.14946 19.0136 4.73032 19.0001 5.33V20C18.999 20.1745 18.9523 20.3457 18.8646 20.4966C18.7769 20.6475 18.6512 20.7727 18.5001 20.86C18.3481 20.9478 18.1756 20.994 18.0001 20.994C17.8246 20.994 17.6521 20.9478 17.5001 20.86L11.8301 17.65L6.50009 20.85C6.34964 20.9434 6.1771 20.9951 6.00009 21Z",
    fill: "#03606A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookmark2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookmark2.37335b7e.svg";
export { ForwardRef as ReactComponent };